import { ArrowUpRight } from "lucide-react";
import { Section, Reveal } from "@/components/site/Primitives";
import { safeHref } from "@/lib/format";

export const ParentLink = ({ parent, className = "", testid = "explore-parent-link" }) =>
  parent?.url ? (
    <a href={safeHref(parent.url)} target="_blank" rel="noopener" className={`inline-flex items-center gap-1 text-[#00E5FF] hover:text-white ${className}`} data-testid={testid}>
      {parent.explore_label || `Explore ${parent.name}`}<ArrowUpRight size={14} />
    </a>
  ) : null;

export const AboutSection = ({ index, site }) => {
  const p = site.parent || {};
  return (
    <Section id="about" index={index}>
      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <Reveal className="lg:col-span-5">
          <img src="/brand/logo-wide.png" alt="EditBay by Relatable Studio" className="w-full max-w-[420px] h-auto" loading="lazy" />
        </Reveal>
        <Reveal className="lg:col-span-7" delay={0.1}>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight" data-testid="about-title">{p.about_title}</h2>
          <p className="mt-6 text-zinc-300 text-lg leading-relaxed" data-testid="about-body">{p.about_body}</p>
          {p.about_note && <p className="mt-4 text-sm text-zinc-500">{p.about_note}</p>}
          <ParentLink parent={p} className="mt-8 text-sm" />
        </Reveal>
      </div>
    </Section>
  );
};
